module.exports = __webpack_public_path__ + "img/15.e52908c3.gif";